<template>
  <div class="modal report-modal">
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="container">
        <img class="close" @click="closeModal" src="./../images/close.svg" />
        <div class="title small">
          {{
            $t(
              "We've sent you an email with a link to reset your password. Please check your e-mail"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecoverSuccessModal",
  props: [],
  data: function () {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
